"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AbstractInitializer_1 = __importDefault(require("../AbstractInitializer"));
const asyncIterate_1 = __importDefault(require("../../../../Util/asyncIterate"));
const arrayMaker_1 = require("../../../../Util/arrayMaker");
const getIsBehaviorDayIterator_1 = __importDefault(require("../Maker/getIsBehaviorDayIterator"));
const getIsDoneIterator_1 = __importDefault(require("../Maker/getIsDoneIterator"));
class BehaviourInitializer extends AbstractInitializer_1.default {
    constructor(cache, behaviourModel, customerRepository, dateTimeModifier, dateTimeProvider) {
        super("behaviour_initializer", cache);
        this.initialize = async () => {
            const currentDate = this.dateTimeProvider.currentDate();
            const isBehaviourDayIterator = (0, getIsBehaviorDayIterator_1.default)();
            const isDoneIterator = (0, getIsDoneIterator_1.default)();
            const behaviourValues = [];
            await (0, asyncIterate_1.default)(await this.customerRepository.getCustomers(), async (customer) => {
                const daysDiff = Math.abs(this.dateTimeModifier.daysDiff(customer.subscriptionPeriod.startDate, currentDate)) + 1;
                let lessonNumber = 1;
                behaviourValues.push({
                    customerId: customer.id,
                    days: await (0, arrayMaker_1.asyncArrayMaker)(daysDiff, async (index) => {
                        const date = await this.dateTimeProvider.fromDateTimeToDate(this.dateTimeModifier.modifyDays(customer.subscriptionPeriod.startDate, index));
                        const isBehaviour = isBehaviourDayIterator.next();
                        const isDone = isBehaviour ? isDoneIterator.next() : null;
                        return {
                            day: this.dateTimeProvider.dayOfWeek(date),
                            date,
                            isDone: isDone,
                            lessonOrdinalNumber: isBehaviour ? lessonNumber++ : null,
                            lessonTitle: isBehaviour ? "How to do things" : null,
                            lessonDescription: isBehaviour ? "How to do things" : "",
                            memberAnswer: {
                                imageUrl: isDone ? "https://via.placeholder.com/300" : "",
                                content: isDone ? "Not sure yet" : "",
                            },
                        };
                    }),
                });
            });
            await (0, asyncIterate_1.default)(behaviourValues, (customerBehaviour) => {
                return (0, asyncIterate_1.default)(customerBehaviour.days, (day) => this.behaviourModel.setBehaviourDay(customerBehaviour.customerId, day));
            });
        };
        this.dateTimeModifier = dateTimeModifier;
        this.dateTimeProvider = dateTimeProvider;
        this.behaviourModel = behaviourModel;
        this.customerRepository = customerRepository;
    }
}
exports.default = BehaviourInitializer;
//# sourceMappingURL=BehaviourInitializer.js.map